export default __webpack_public_path__ + "static/screeny-150-gpz-unica-3-e872bb5ec09b9543a44d3b1cfb6f8b59.jpg";